// Manage camera dialog only for Android
(function () {
    let CameraPreviewController = (function () {
        function CameraPreviewController($scope, $q, mdPanelRef, UtilityService, onClose, DeviceService, $timeout) {
            $scope.vm = this;
            this.$scope = $scope;
            this.$q = $q;
            this.mdPanelRef = mdPanelRef;
            this.utilityService = UtilityService;
            this.onClose = onClose;
            this.deviceService = DeviceService;
            this.$timeout = $timeout;
            this.options = {
                x: 0,
                y: 0,
                camera: window['CameraPreview'].CAMERA_DIRECTION.BACK,
                toBack: false,
                tapPhoto: false,
                tapFocus: false,
                previewDrag: false,
                storeToFile: false,
                disableExifHeaderStripping: false,
                withFlash: false
            };
        }

        CameraPreviewController.prototype = {
            /** @type {boolean} blockedCamera: Block camera when take picture */
            blockedCamera: false,
            init() {
                this.$element = $('.camera_preview');
                this.afterOpened();
            },
            close(base65Data) {
                let blob;
                if (base65Data) {
                    blob = this.b64toBlob(base65Data, 'image/jpeg');
                    blob['name'] = this.utilityService.createUUID() + '_camera.jpeg';
                    blob['lastModifiedDate'] = new Date();
                    blob['lastModified'] = new Date();
                }
                this.beforeClosed();
                this.onClose(blob);
                this.mdPanelRef.close();
                this.$scope.$destroy(); // Have to destroy $scope when panel is closed
                
                // Remoce event listener
                $(window).off('resize.CameraPreviewController orientationchange.CameraPreviewController');
                
                // Remove camera
                document.documentElement.classList.remove('safe-area-inset-camera')
            },
            onTakeCameraClick() {
                window['CameraPreview'].takePicture((base64PictureData) => {
                    this.close(base64PictureData);
                });
            },
            onSwitchCameraClick() {
                this.options.camera = this.options.camera === window['CameraPreview'].CAMERA_DIRECTION.BACK ? window['CameraPreview'].CAMERA_DIRECTION.FRONT : window['CameraPreview'].CAMERA_DIRECTION.BACK;
                this.resetCamera(); // Reset cameta when switch
            },
            onCancelClick() {
                this.close();
            },

            /**
             * Show Camera after dialog show complete
             */
            afterOpened() {
                let container = $('.camera-container', this.$element);
                 // Full screen when
                document.documentElement.classList.add('safe-area-inset-camera')
                
                this.updateClass();
                Object.assign(this.options, {
                    width: container.width(),
                    height: container.height(),
                    x: container.offset().left,
                    y: container.offset().top
                });
                this.blockedCamera = true;
                
                // Start camera
                this.startCamera(this.options);

                // NF-819: Prevent fire  backbutton to other screen
                this.deviceService.preventBackButton(this.$scope);

                // Close dialog when go back
                window['CameraPreview'].onBackButton(() => {
                    this.$timeout(()=>{ // Delay to prevent prev screen will close
                        this.onCancelClick();
                    }, 500);
                });
                
                


                (function bindResize(){
                    let timer;
                    function debounce(func) {
                        return function (event) {
                            if (timer) {
                                clearTimeout(timer);
                            }
                            timer = setTimeout(func, 500, event);
                        };
                    }
                    
            
                    $(window).on('resize.CameraPreviewController orientationchange.CameraPreviewController', debounce(() => {
                       this.resetCamera();
                    }))
 

                }).apply(this);
                

                

            },

            resetCamera() {
                if (this.blockedCamera) {
                    return;
                }
                let container = $('.camera-container', this.$element);
                this.updateClass();
                let newPosition = {
                    width: container.width(),
                    height: container.height(),
                    x: container.offset().left,
                    y: container.offset().top
                };
                this.blockedCamera = true;// lock camera
                this.stopCamera(() => {
                    Object.assign(this.options, newPosition);
                    this.startCamera(this.options);
                }, () => {
                    this.blockedCamera = false;
                });
            },
            
            startCamera(options, onSuccess, onError){
                window['CameraPreview'].startCamera(options,()=>{
                    // Close dialog when go back
                    this.blockedCamera = false;
                    if(onSuccess){
                        onSuccess();
                    }
                },()=>{
                    this.blockedCamera = false;
                    if(onError){
                        onError();
                    }
                });
            },
            
            stopCamera(onSuccess, onError){
                CameraPreview.stopCamera(() => {
                   onSuccess();
                }, () => {
                   setTimeout(()=>{
                        this.stopCamera(onSuccess, onError);
                   }, 500)
                });
            },
            
            beforeClosed() {
                window['CameraPreview'].stopCamera();
            },
            /**
             * Convert base64 to blob
             * @param b64Data
             * @param contentType
             * @private
             */
            b64toBlob(b64Data, contentType = '') {
                let sliceSize = 512;
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                return new Blob(byteArrays, {type: contentType});
            },
            

            
            updateClass(){
               let container = $(this.$element);
               container.removeClass('portrait-primary portrait-secondary landscape-secondary landscape-primary');
               container.addClass(screen.orientation.type);
            }

        };
        CameraPreviewController.$inject = [
            '$scope',
            '$q',
            'mdPanelRef',
            'UtilityService',
            'onClose',
            'DeviceService',
            '$timeout'
        ];
        return CameraPreviewController;
    }());
    angular.module('shared.camera.CameraPreviewController', []).controller('CameraPreviewController', CameraPreviewController);
})();

